import { useEffect, useState, useCallback } from "react";
import { ApiServices } from '../services/apiServices';

type HttpMethod = 'get' | 'post' | 'delete' | 'put' | 'patch';

interface FetchOptions<T> {
    method?: HttpMethod;
    body?: any;
    trigger?: boolean;
}

export default function useFetch<T = any>(url: string | null, options?: FetchOptions<T>) {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<Error | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [refetchIndex, setRefetchIndex] = useState(0);

    const refetch = useCallback(() => {
        setRefetchIndex(prev => prev + 1);
    }, []);

    useEffect(() => {
        if (!url || (options?.method !== 'get' && !options?.trigger)) return;
        (async function () {
            try {
                setLoading(true);
                const response = await ApiServices(options?.method || 'get', url, options?.body);
                setData(response.data);
            } catch (err: any) {
                setError(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [url, options?.method, options?.body, options?.trigger, refetchIndex]);

    return { data, error, loading, refetch };
}
